import { render, staticRenderFns } from "./news-analys.vue?vue&type=template&id=1a819aa4&scoped=true&"
import script from "./news-analys.vue?vue&type=script&lang=js&"
export * from "./news-analys.vue?vue&type=script&lang=js&"
import style0 from "./news-analys.vue?vue&type=style&index=0&id=1a819aa4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a819aa4",
  null
  
)

export default component.exports